import theme from "app/Theme/Theme";
import React from "react";
import Svg, { Path } from "react-native-svg";

const VideoIcon = ({ width, height, color }) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      preserveAspectRatio="xMidYMin meet"
      backgroundColor="transparent"
    >
      <Path
        d="M10.0001 18.315C14.5672 18.315 18.2696 14.6126 18.2696 10.0455C18.2696 5.4783 14.5672 1.77588 10.0001 1.77588C5.43289 1.77588 1.73047 5.4783 1.73047 10.0455C1.73047 14.6126 5.43289 18.315 10.0001 18.315Z"
        stroke={color}
        fill={"transparent"}
        strokeWidth="2"
      />
      <Path
        d="M9.8457 10.5507V9.54057L10.6033 10.0456L9.8457 10.5507Z"
        stroke={color}
        strokeWidth="3"
      />
    </Svg>
  );
};

VideoIcon.defaultProps = {
  width: 20,
  height: 20,
  color: theme.colors["neutral.white"],
};

export default VideoIcon;
